<div class="zoom-image-container" #imageContainer>
  <img
    #image
    class="zoom-display-image"
    [src]="imageSrc"
    (load)="addZoom()"
  />
</div>
